// Monzzaro site JS (ponytail: no framework, no scroll libs)
// theme toggle — dark default, localStorage persisted, pre-paint class set in <head>
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.theme-toggle').forEach(function(b){
    b.addEventListener('click', function(){
      var dark = document.documentElement.classList.toggle('dark');
      localStorage.setItem('mz-theme', dark ? 'dark' : 'light');
    });
  });
});
(function(){
  var header = document.getElementById('siteHeader');
  if(!header) return;
  // menu toggle / cart drawer / wheel / search all live in js/menu.js (shared)
  // header shadow on scroll
  var ticking = false;
  window.addEventListener('scroll', function(){
    if(ticking) return; ticking = true;
    requestAnimationFrame(function(){
      header.classList.toggle('shadowed', window.scrollY > 8);
      header.classList.toggle('scrolled', window.scrollY > 60); // brand: stamp -> wordmark
      ticking = false;
    });
  }, {passive:true});
})();

// header mirrors the background of whichever fold is under it
(function(){
  var header = document.getElementById('siteHeader');
  if(!header) return;
  var secs = Array.prototype.slice.call(document.querySelectorAll('main > section, main > .page-body, .site-footer'));
  function bgOf(el){
    var bg = getComputedStyle(el).backgroundColor;
    return (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent')
      ? getComputedStyle(document.body).backgroundColor : bg;
  }
  function lum(c){
    var m = c.match(/[\d.]+/g); if(!m || m.length < 3) return 1;
    var v = [+m[0], +m[1], +m[2]];
    if(c.indexOf('color(srgb') !== 0){ v = v.map(function(x){ return x/255; }); }
    return .2126*v[0] + .7152*v[1] + .0722*v[2];
  }
  function update(){
    var y = header.getBoundingClientRect().bottom + 1;
    for(var i=0;i<secs.length;i++){
      var r = secs[i].getBoundingClientRect();
      if(r.top <= y && r.bottom > y){
        var bg = bgOf(secs[i]);
        // fold-1 keeps the header transparent; every later fold paints it
        header.style.background = (secs[i].id === 'hero') ? 'transparent' : bg;
        header.classList.toggle('on-dark', lum(bg) < .45);
        return;
      }
    }
  }
  window.addEventListener('scroll', function(){ requestAnimationFrame(update); }, {passive:true});
  // accent swap (tab click) changes the hero bg without scrolling — re-sync after its transition
  new MutationObserver(function(){ update(); setTimeout(update, 600); })
    .observe(document.body, {attributes:true, attributeFilter:['data-accent']});
  // transparent overlay header: the fold underneath extends to the top of the page
  var main = document.querySelector('main.home');
  function lift(){ if(main) main.style.marginTop = -header.offsetHeight + 'px'; }
  window.addEventListener('resize', lift);
  lift();
  update();
})();

// CurvedLoop — vanilla port of React Bits <CurvedLoop /> (SVG textPath marquee, drag-interactive)
(function(){
  var band = document.querySelector('.curved-band');
  var measure = document.getElementById('curveMeasure');
  var tp = document.getElementById('curveTextPath');
  if(!band || !measure || !tp) return;

  var SPEED = 1.4, dir = 'left';
  var spacing = 0, dragging = false, lastX = 0, vel = 0;
  var text = measure.textContent; // one tile incl trailing nbsp

  function init(){
    spacing = measure.getComputedTextLength();
    if(!spacing){ requestAnimationFrame(init); return; }
    var reps = Math.ceil(1800 / spacing) + 2;
    tp.textContent = new Array(reps + 1).join(text);
    tp.setAttribute('startOffset', (-spacing) + 'px');
    requestAnimationFrame(step);
  }
  function wrap(o){
    if(o <= -spacing) o += spacing;
    if(o > 0) o -= spacing;
    return o;
  }
  function step(){
    if(!dragging){
      var o = parseFloat(tp.getAttribute('startOffset')) || 0;
      tp.setAttribute('startOffset', wrap(o + (dir === 'right' ? SPEED : -SPEED)) + 'px');
    }
    requestAnimationFrame(step);
  }
  band.addEventListener('pointerdown', function(e){
    dragging = true; lastX = e.clientX; vel = 0;
    band.classList.add('dragging');
    band.setPointerCapture(e.pointerId);
  });
  band.addEventListener('pointermove', function(e){
    if(!dragging) return;
    var dx = e.clientX - lastX; lastX = e.clientX; vel = dx;
    var o = parseFloat(tp.getAttribute('startOffset')) || 0;
    tp.setAttribute('startOffset', wrap(o + dx) + 'px');
  });
  function endDrag(){
    if(!dragging) return;
    dragging = false; dir = vel > 0 ? 'right' : 'left';
    band.classList.remove('dragging');
  }
  band.addEventListener('pointerup', endDrag);
  band.addEventListener('pointerleave', endDrag);

  // fonts load late -> re-measure once ready
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(init); }
  else { init(); }
})();

// CircularText — vanilla port of React Bits <CircularText/> (rAF spin, hover speedUp)
function buildRing(el, text){
  el.innerHTML = '';
  var letters = Array.from(text);
  letters.forEach(function(ch,i){
    var s = document.createElement('span');
    s.textContent = ch;
    s.style.transform = 'rotateZ(' + (360/letters.length)*i + 'deg)';
    el.appendChild(s);
  });
}
(function(){
  document.querySelectorAll('[data-circtext]').forEach(function(el){
    buildRing(el, el.getAttribute('data-circtext'));
    var SPIN = 15;            // seconds per rotation
    var speed = 360/SPIN;     // deg/sec
    var target = speed, cur = speed, angle = 0, last = null;
    el.addEventListener('mouseenter', function(){ target = speed*4; }); // speedUp
    el.addEventListener('mouseleave', function(){ target = speed; });
    function step(ts){
      if(last !== null){
        cur += (target-cur)*0.08;                    // ease toward target speed
        angle = (angle + cur*(ts-last)/1000) % 360;
        el.style.transform = 'rotate(' + angle + 'deg)';
      }
      last = ts;
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  });
})();

// Cinematic stage — one centered bottle, dual dials (collections top / perfumes bottom)
(function(){
  var wrap  = document.getElementById('heroCarousel');
  var stage = document.getElementById('stage');
  if(!wrap || !stage) return;
  var ring = document.getElementById('heroRing');
  var imgs = Array.prototype.slice.call(document.querySelectorAll('.stage-img'));
  var stageName = document.getElementById('stageName');
  var stageLine = document.getElementById('stageLine');
  var stageWord = document.getElementById('stageWord');
  var stageEdition = document.getElementById('stageEdition');
  var metaPrice = document.getElementById('metaPrice');
  var metaSizes = document.getElementById('metaSizes');
  var perfDial = document.getElementById('perfDial');
  var collTabs = document.getElementById('collTabs');

  // per-perfume data — names/lines/prices note-checked against mz-info
  var DATA = [
    {name:'Midsea Murmur',    line:'The Daily Signature \u2014 fresh marine that lands in warm wood.',      accent:'midsea',  ring:'FRESH TO WARM | ',      price:{'60ml':'\u20B93,519','20ml':'\u20B91,419'}},
    {name:'Divine Dilemma',   line:'The Compliment Getter \u2014 bright citrus into soft amber musk.',      accent:'divine',  ring:'BRIGHT TO SOFT | ',     price:{'60ml':'\u20B93,499','20ml':'\u20B91,409'}},
    {name:'Crown Cardinal',   line:'The Authority Stamp \u2014 fruity citrus into spiced royal oud.',       accent:'crown',   ring:'SHARP TO ROYAL | ',     price:{'60ml':'\u20B93,499','20ml':'\u20B91,409'}},
    {name:'Black Sunset',     line:'The Last Impression \u2014 cool spice into smoky oud.',                 accent:'bsunset', ring:'COOL TO SMOKE | ',      price:{'60ml':'\u20B93,589','20ml':'\u20B91,439'}},
    {name:'Rich Reverie',     line:'The Night Magnet \u2014 fruity florals into creamy vanilla.',              accent:'rich',    ring:'COFFEE TO CREAM | ',    price:{'60ml':'\u20B93,419','20ml':'\u20B91,379'}},
    {name:"Rose O'Clock",     line:'The Romantic Signature \u2014 bright fruit into a blooming rose.',      accent:'rose',    ring:'FRUIT TO BLOOM | ',     price:{'60ml':'\u20B93,659','20ml':'\u20B91,459'}},
    {name:'Oud of the Ocean', line:'A genuine aquatic oud, built for every season.',                        accent:'ocean',   ring:'FRESH AQUATIC OUD | ',  price:{'50ml':'\u20B91,499'}},
    {name:'Oud of the Storm', line:'The Maison\u2019s statement extrait \u2014 after dark, and it stays.', accent:'storm',   ring:'SPICY RESINOUS OUD | ', price:{'50ml':'\u20B91,899'}},
    {name:'Saharan Spice',    line:'Desert warmth \u2014 dry spice, no sugar.',                            accent:'saharan', ring:'DRY SPICY WOODY | ',    price:{'50ml':'\u20B91,499'}},
    {name:'Silk Blush',       line:'Soft luxury \u2014 silk, worn as a scent.',                            accent:'silk',    ring:'FLORAL GOURMAND | ',    price:{'50ml':'\u20B91,499'}}
  ];
  var IDX = {epos:[0,1,2,3,4,5], oud:[6,7], cristallo:[8,9]};

  // LHS copy per collection — 4UP + Indian Proof pass (visible proof beats; notes stay mz-info-true)
  var SETS = {
    epos: {copy: {
      eyebrow: 'Act I: Dusk \u00B7 Numbered first editions',
      h1: 'SIX ORIGINALS<br>THAT OPEN AS<br><span class="shiny">ONE SCENT</span><br>AND LAND AS<br><span class="shiny">ANOTHER.</span>',
      pain: 'You know the moment. A lift, a wedding, a meeting \u2014 and half the room is wearing the same few famous scents. You paid for a signature and got a uniform.',
      body: 'Maison Monzzaro was built against that moment. Six original compositions, made in-house and made nowhere else, each built on <strong>Dyadic Olfaction</strong>: it opens as one scent and, over the hours, lands as another. Two fragrances in a single wear \u2014 so when someone leans in and asks what you\u0027re wearing, the answer is yours alone.',
      claim: 'Not a clone. Yours.',
      ctaHref: 'collection-epos.html',
      prices: 'Epos 60ml from \u20B93,419 \u00B7 Discovery Set 6\u00D75ml \u20B91,949 \u00B7 Free shipping across India',
      num: '<strong>N\u00BA 001</strong> \u2014 FIRST EDITION. WHEN ACT I IS GONE, IT IS NOT PRINTED AGAIN.'
    }},
    oud: {copy: {
      eyebrow: 'La Collezione Oud \u00B7 The signature house',
      h1: 'THE OUD<br>THAT ROSE<br><span class="shiny">FROM THE SEA,</span><br>AND THE ONE<br><span class="shiny">THE STORM LEFT.</span>',
      pain: 'Most oud is a wall of smoke \u2014 heavy, dated, the same dark room in every bottle. You wanted presence, not a costume.',
      body: 'Two artistic ouds, 50 ml each, made in-house. <strong>Oud of the Ocean</strong> opens on saffron, mint and marine air and settles into oud, tobacco and musk \u2014 the signature that walks into the room before you do. <strong>Oud of the Storm</strong> charges saffron and mandarin with frankincense, then lands on oud, leather and moss \u2014 worn for power, after dark.',
      claim: 'Oud, without the costume.',
      ctaHref: 'collection-oud.html',
      prices: 'Oud of the Ocean 50ml \u20B91,499 \u00B7 Oud of the Storm 50ml \u20B91,899 \u00B7 Free shipping across India',
      num: '<strong>LA COLLEZIONE OUD</strong> \u2014 THE HOUSE\u0027S SIGNATURE. MADE IN-HOUSE, MADE NOWHERE ELSE.'
    }},
    cristallo: {copy: {
      eyebrow: 'La Collezione Cristallo \u00B7 Refined originals',
      h1: 'TWO ORIGINALS<br>CUT IN<br><span class="shiny">CRYSTAL \u2014</span><br>DESERT AND<br><span class="shiny">SILK.</span>',
      pain: 'The refined middle is where most houses coast \u2014 safe, polite scents that smell like everyone\u0027s idea of nice. Refined should never mean invisible.',
      body: 'Two refined originals in faceted crystal-cut glass, 50 ml each \u2014 the bottle gets noticed before the scent does. <strong>Saharan Spice</strong> runs Sicilian bergamot and pink pepper into agarwood, leather and musk \u2014 dry desert warmth, no sugar rush. <strong>Silk Blush</strong> drapes Italian lemon and Turkish rose over bourbon vanilla and white musk, resting on cedarwood and a trace of sugar \u2014 soft luxury, worn close.',
      claim: 'Refined. Never invisible.',
      ctaHref: 'collection-cristallo.html',
      prices: 'Saharan Spice 50ml \u20B91,499 \u00B7 Silk Blush 50ml \u20B91,499 \u00B7 Free shipping across India',
      num: '<strong>CRYSTAL-CUT ORIGINALS</strong> \u2014 DESERT WARMTH AND SOFT FLORAL, MADE IN-HOUSE.'
    }}
  };

  var copyEls = {
    eyebrow: document.querySelector('.hero-copy .eyebrow'),
    h1:      document.querySelector('.hero-copy h1'),
    pain:    document.querySelector('.hero-pain'),
    body:    document.querySelector('.manifesto-body'),
    claim:   document.querySelector('.hero-claim'),
    cta:     document.querySelector('.hero-ctas .cta'),
    prices:  document.querySelector('.hero-prices')
  };
  function applyCopy(c){
    if(!c || !copyEls.h1) return;
    copyEls.eyebrow.textContent = c.eyebrow;
    copyEls.h1.innerHTML = c.h1;
    copyEls.pain.textContent = c.pain;
    copyEls.body.innerHTML = c.body;
    copyEls.claim.textContent = c.claim;
    copyEls.cta.setAttribute('href', c.ctaHref);
    copyEls.prices.textContent = c.prices;
    stageEdition.innerHTML = c.num;
  }

  var coll = 'epos', pi = 0, size = null;
  function mod(n,m){ return ((n % m) + m) % m; }

  function reseat(){
    requestAnimationFrame(function(){
      if(collTabs.__seatChip) collTabs.__seatChip();
      if(perfDial.__seatChip) perfDial.__seatChip();
    });
  }

  function setPerfume(i){
    pi = mod(i, IDX[coll].length);
    var d = DATA[IDX[coll][pi]];
    imgs.forEach(function(im,k){ im.style.setProperty('--drag-x','0px'); im.classList.toggle('active', k === IDX[coll][pi]); });
    document.body.setAttribute('data-accent', d.accent);
    if(ring) buildRing(ring, d.ring);
    stageName.textContent = d.name;
    stageLine.textContent = d.line;
    stageWord.textContent = d.name.toUpperCase();
    var sizes = Object.keys(d.price);
    if(!d.price[size]) size = sizes[0];
    metaSizes.innerHTML = '';
    sizes.forEach(function(s){
      var b = document.createElement('button');
      b.textContent = s.toUpperCase();
      b.classList.toggle('active', s === size);
      b.addEventListener('click', function(){
        size = s; metaPrice.textContent = d.price[s];
        Array.prototype.forEach.call(metaSizes.children, function(x){ x.classList.toggle('active', x === b); });
      });
      metaSizes.appendChild(b);
    });
    metaPrice.textContent = d.price[size];
    Array.prototype.forEach.call(perfDial.querySelectorAll('button'), function(b,k){ b.classList.toggle('active', k === pi); });
    reseat();
  }

  function buildDial(){
    perfDial.innerHTML = '';
    perfDial.__chipInit = false;
    IDX[coll].forEach(function(gi,k){
      var b = document.createElement('button');
      b.setAttribute('role','tab');
      b.textContent = 'N\u00BA 0' + (k+1);
      b.addEventListener('click', function(){ setPerfume(k); });
      perfDial.appendChild(b);
    });
    if(window.initMetalChip) window.initMetalChip(perfDial);
  }

  function setColl(key){
    coll = key; size = null;
    applyCopy(SETS[key].copy);
    buildDial();
    setPerfume(0);
  }

  collTabs.addEventListener('click', function(ev){
    var btn = ev.target.closest('button'); if(!btn || !IDX[btn.getAttribute('data-coll')]) return;
    Array.prototype.forEach.call(collTabs.querySelectorAll('button'), function(b){ b.classList.toggle('active', b === btn); });
    setColl(btn.getAttribute('data-coll'));
  });

  // gestures: one perfume per gesture (wheel / arrows / drag)
  var lock = false;
  function step(d){
    if(lock) return; lock = true;
    setPerfume(pi + d);
    setTimeout(function(){ lock = false; }, 450);
  }
  wrap.addEventListener('wheel', function(ev){
    ev.preventDefault();
    var d = Math.abs(ev.deltaY) > Math.abs(ev.deltaX) ? ev.deltaY : ev.deltaX;
    if(Math.abs(d) < 4) return;
    step(d > 0 ? 1 : -1);
  }, {passive:false});
  wrap.addEventListener('keydown', function(ev){
    if(ev.key === 'ArrowRight'){ ev.preventDefault(); step(1); }
    if(ev.key === 'ArrowLeft'){ ev.preventDefault(); step(-1); }
  });
  // drag dynamics from the old circular gallery: follows the finger, snaps one step,
  // tap left/right third steps back/forward
  var downX = null, moved = 0;
  function activeImg(){ return document.querySelector('.stage-img.active'); }
  stage.addEventListener('pointerdown', function(ev){
    downX = ev.clientX; moved = 0;
    stage.classList.add('dragging');
    try{ stage.setPointerCapture(ev.pointerId); }catch(e){}
  });
  stage.addEventListener('pointermove', function(ev){
    if(downX === null) return;
    var dx = ev.clientX - downX; moved = Math.max(moved, Math.abs(dx));
    var im = activeImg();
    if(im) im.style.setProperty('--drag-x', (dx*0.35) + 'px');   // bottle follows the finger
  });
  function releaseStage(ev){
    if(downX === null) return;
    var dx = ev.clientX - downX; downX = null;
    stage.classList.remove('dragging');
    var im = activeImg();
    if(im) im.style.setProperty('--drag-x', '0px');
    if(moved < 8){                                   // tap: left third back, right third forward
      var fx = (ev.clientX - stage.getBoundingClientRect().left) / stage.clientWidth;
      if(fx < 0.35) step(-1);
      else if(fx > 0.65) step(1);
    } else if(Math.abs(dx) > 48){
      step(dx < 0 ? 1 : -1);
    }
  }
  stage.addEventListener('pointerup', releaseStage);
  stage.addEventListener('pointercancel', function(){ downX = null; stage.classList.remove('dragging'); var im = activeImg(); if(im) im.style.setProperty('--drag-x','0px'); });

  // per-bottle fit: equalize visible heights + align bases (alpha-scanned bounds; base target 71%)
  var FIT = [
    {s:1.0, dy:0, o:100},  // midsea
    {s:1.0, dy:0, o:100},  // divine
    {s:1.0, dy:0, o:100},  // crown
    {s:1.0, dy:0, o:100},  // black sunset
    {s:1.0, dy:0, o:100},  // rich
    {s:1.0, dy:0, o:100},  // rose
    {s:1.0, dy:0, o:100},  // oud ocean
    {s:1.0, dy:0, o:100},  // oud storm
    {s:1.0, dy:0, o:100},  // saharan
    {s:1.0, dy:0, o:100},   // silk
  ];
  imgs.forEach(function(im,k){
    var f = FIT[k]; if(!f) return;
    im.style.setProperty('--fit-s', f.s);
    im.style.setProperty('--fit-dy', f.dy + '%');
    im.style.setProperty('--fit-o', f.o + '%');
  });

  applyCopy(SETS.epos.copy);
  buildDial();
  setPerfume(0);
})();
